// extracted by mini-css-extract-plugin
module.exports = {"one":"one___2vYks","two":"two___3AgT4"};